export default __webpack_public_path__ + "static/media/add-series.8e2be2d2.svg";